<p-tabs
  [(value)]="requestApprovalActiveTab"
  (valueChange)="reqApprovalOnTabChange($event)"
  scrollable
  style="padding-bottom: 12px !important"
>
  <p-tablist>
    <p-tab *ngFor="let tab of reqApprovalTabs; index as i" [value]="i">
      {{ tab.label }}
      @if (tab.showBadge) {
        <p-badge
          [value]="tab.reqBadgeCount || 0"
          badgeSize="small"
          severity="danger"
        />
      }
    </p-tab>
  </p-tablist>
</p-tabs>
<p-card styleClass="border-none shadow-none mb-1 p-0 custom-card-scope">
  <p-table
    #reqApprovalTable
    [value]="requestApprovalDataFiltered"
    [paginator]="true"
    [columns]="requestApprovalColumn"
    [rows]="10"
    [style]="{ width: '100%' }"
    [tableStyle]="{ 'table-layout': 'fixed', width: '100%' }"
    size="small"
    [(selection)]="selectedBulkApprovalData"
    dataKey="taskDate"
    stripedRows="true"
    appendTo="body"
    [rowsPerPageOptions]="[10, 50, 100, 200]"
    selectionMode="multiple"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [globalFilterFields]="[
      'taskDate',
      'loggedHours',
      'status',
      'comments',
      'approvedOn',
      'approvedByName',
      'totalTimeSpent',
    ]"
  >
    <ng-template #caption>
      <div class="flex justify-between items-center w-full flex-wrap gap-4">
        <div class="flex items-center gap-4 flex-wrap">
          <p-button
            *ngIf="
              this.reqApprovalTabs[this.requestApprovalActiveTab].label !==
                requestApprovalStatus.Approved &&
              this.reqApprovalTabs[this.requestApprovalActiveTab].label !==
                requestApprovalStatus.Submitted
            "
            icon="pi pi-send"
            label="Bulk Submit"
            (onClick)="submitForApproval($event, '', true)"
            [pTooltip]="
              isBulkSubmitDisabled
                ? 'Cannot Submit because no entries found for the date'
                : ''
            "
            [disabled]="selectedBulkApprovalData.length === 0"
          ></p-button>
          <p-button
          *ngIf="
            this.reqApprovalTabs[this.requestApprovalActiveTab].label ===
              requestApprovalStatus.Submitted
          "
          icon="pi pi-undo"
          label="Bulk Pull Back"
          (onClick)="pullBackSubmission('', true)"
          [disabled]="selectedBulkApprovalData.length === 0"
          ></p-button>
        </div>

        <div class="flex items-center gap-2">
          <p-floatlabel class="w-[220px]" variant="on">
            <p-datepicker
              [(ngModel)]="dateRange"
              selectionMode="range"
              dateFormat="yy-mm-dd"
              showIcon="true"
              [minDate]="reqApprovalMinDate"
              [maxDate]="reqApprovalMaxDate"
            />
            <label for="dateRange">Date Range</label>
          </p-floatlabel>

          <p-button
            icon="pi pi-check"
            label="Apply"
            (onClick)="requestApproval()"
          />
          <p-button
            label=""
            icon="pi pi-filter-slash"
            severity="secondary"
            class=""
            pTooltip="Clear Filters"
            (onClick)="clearFilters()"
          />
          <p-iconfield iconPosition="left">
            <p-inputicon>
              <i class="pi pi-search"></i>
            </p-inputicon>
            <input
              #searchInput
              [(ngModel)]="requestApprovalGlobalSearch"
              pInputText
              type="text"
              (input)="
                reqApprovalTable.filterGlobal(searchInput.value, 'contains')
              "
              placeholder="Search Time Entries"
            />
          </p-iconfield>
        </div>
      </div>
    </ng-template>

    <!-- Header for table columns -->
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th
          *ngFor="let column of requestApprovalColumn"
          [pSortableColumn]="column.field"
          [style.width]="column.width"
        >
          <ng-container *ngIf="column.type === 'selection'">
            <div class="flex items-center justify-center gap-2">
              <p-tableHeaderCheckbox [disabled]="isBulkSubmitDisabled" />
            </div>
          </ng-container>

          <div class="flex items-center gap-2">
            {{ column.header }}
          </div>
        </th>
      </tr>
    </ng-template>

    <!-- Table body with checkboxes and data -->
    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
      <tr>
        <td
          *ngFor="let item of requestApprovalColumn"
          [style.width]="item.width"
        >
          <!-- Selection checkbox -->
          <ng-container *ngIf="item.type === 'selection'">
            @if (
              rowData.status !== requestApprovalStatus.Submitted ||
              this.reqApprovalTabs[this.requestApprovalActiveTab].label ===
                requestApprovalStatus.Submitted
            ) {
              <p-tableCheckbox
                [disabled]="rowData['totalTimeSpent'] === '00:00'"
                class="flex items-center justify-center gap-2"
                [value]="rowData"
              />
            }
          </ng-container>

          <!-- Actions or data for other columns -->
          <ng-container *ngIf="item.type === 'actions'">
            @if (rowData.status !== requestApprovalStatus.Submitted) {
              <p-button
                label="Submit"
                [disabled]="rowData['totalTimeSpent'] === '00:00'"
                [pTooltip]="
                  rowData['totalTimeSpent'] === '00:00'
                    ? 'Cannot Submit because no entries found for the date'
                    : ''
                "
                (onClick)="submitForApproval($event, rowData.taskDate, false)"
              ></p-button>
            }
            <!-- label="Request Approval" -->
            <!--Pull Back button for Submitted rows -->
            @if (rowData.status === requestApprovalStatus.Submitted) {
              <p-button
                label="Pull Back"
                icon="pi pi-undo"
                pTooltip="Pull back this submission"
                tooltipPosition="top"
                (onClick)="pullBackSubmission(rowData.taskDate)"
              ></p-button>
            }
          </ng-container>

          <ng-container
            *ngIf="item.type !== 'selection' && item.type !== 'actions'"
          >
            <span
              #textEl
              [pTooltip]="shouldShowTooltip ? rowData[item.field] : null"
              tabindex="0"
              role="button"
              tooltipPosition="top"
              [style.maxWidth]="item.width"
              [style.width]="item.width"
              class="truncate inline-block overflow-hidden text-ellipsis"
              (mouseenter)="checkTooltipVisibility(textEl)"
            >
              @if (item.type === 'date') {
                {{ rowData[item.field] | date: 'MM/dd/yyyy' }}
              } @else {
                {{ rowData[item.field] || '-' }}
              }
            </span>
          </ng-container>
        </td>
      </tr>
    </ng-template>

    <!-- No data message -->
    <ng-template #emptymessage>
      <tr>
        <td colspan="7">No entries found.</td>
      </tr>
    </ng-template>
  </p-table>
</p-card>
<div class="card flex justify-center gap-2">
  <!-- <p-toast /> -->
  <p-confirmdialog />
</div>
